import { render, staticRenderFns } from "./SimpleTest.vue?vue&type=template&id=0aa09f75&scoped=true"
import script from "./SimpleTest.vue?vue&type=script&lang=js"
export * from "./SimpleTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa09f75",
  null
  
)

export default component.exports